import React, { useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService';
import axios from 'axios';
import SupportUs from '../supporters/SupportUs';
import PGNViewer from '../../PGNViewer';
import { Switch, Checkbox, Button, TextField, Modal, Box, Grid, Stack, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormGroup, FormControl, FormLabel, FormControlLabel, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { usePromiseTracker } from "react-promise-tracker";
import { trackPromise } from 'react-promise-tracker';
import { Bars, MagnifyingGlass } from "react-loader-spinner";
import AnalyzeOnLichess from './AnalyzeOnLichess';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}



export default function GameById(props) {
    //const { search } = useLocation()
    //const values = queryString.parse(search)
    const [gameId, setGameId] = useState(props.gameId ? props.gameId : (props.match.params.gameId ? props.match.params.gameId : ""));
    //const [gameId, setGameId] = useState(match.params.gameId);
    const [gamePGNString, setGamePGNString] = useState();
    const [event, setEvent] = useState();
    const [date, setDate] = useState();
    const [white, setWhite] = useState();
    const [whiteElo, setWhiteElo] = useState();
    const [whiteFideId, setWhiteFideId] = useState();
    const [whiteUscfId, setWhiteUscfId] = useState();
    const [black, setBlack] = useState();
    const [blackElo, setBlackElo] = useState();
    const [blackFideId, setBlackFideId] = useState();
    const [blackUscfId, setBlackUscfId] = useState();
    const [result, setResult] = useState();
    const [uscfEventId, setUscfEventId] = useState();
    const [fideEventId, setFideEventId] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [screenSize, setScreenSize] = useState(getCurrentDimension());
    const [isAdmin, setIsAdmin] = useState(false);
    const [displayEditButton, setDisplayEditButton] = useState(props.displayEditButton !== undefined ? props.displayEditButton : true);
    const { promiseInProgress } = usePromiseTracker();


    const centerDivStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '20vh'
    }; //https://www.c-sharpcorner.com/blogs/how-to-make-a-div-center-in-screen-in-react-js


    function getCurrentDimension() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }

    useEffect(() => {
        const updateDimension = () => {
            setScreenSize(getCurrentDimension())
        }
        window.addEventListener('resize', updateDimension);

        return (() => {
            window.removeEventListener('resize', updateDimension);
        })
    }, [screenSize])

    useEffect(() => {
        async function getGame() {
            var user = await authService.getUser();
            if (user != null) {
                var role = user.role;
                if (role.includes("Administrators"))
                    setIsAdmin(true);
            }


            var token = await authService.getAccessToken();
            var headers = {
                headers: { 'Authorization': `Bearer ${token}` }
            }
            //try {
            trackPromise(
                axios.get('/api/chessgames/getSingleGame?gamehash=' + gameId, headers).then((response) => {
                    const pgnString = response.data;
                    setGamePGNString(pgnString);
                    pgnString.flatMap((field) => {
                        if (field.includes("[Event ")) {
                            setEvent(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[Date ")) {
                            setDate(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[White ")) {
                            setWhite(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[Black ")) {
                            setBlack(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[WhiteElo ")) {
                            setWhiteElo(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[BlackElo ")) {
                            setBlackElo(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[Result ")) {
                            setResult(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[FideEventId ")) {
                            setFideEventId(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[UscfEventId ")) {
                            setUscfEventId(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[WhiteUscfId ")) {
                            setWhiteUscfId(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[WhiteFideId ")) {
                            setWhiteFideId(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[BlackUscfId ")) {
                            setBlackUscfId(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                        if (field.includes("[BlackFideId ")) {
                            setBlackFideId(field.match(/(?:"[^"]*"|^[^"]*$)/)[0].replace(/"/g, ""));
                        }
                    }
                    );
                }).catch((error) => {
                    console.log(JSON.stringify(error));
                    setErrorMessage(error.response.data);
                }
                )
            )
            
        }
        getGame();
    }, [gameId]); 

    return (
        <div>
            {(promiseInProgress === true) ?
                <Box sx={{ pt: 2, pb: 1 }}>
                    <div style={centerDivStyle}>
                        <MagnifyingGlass ariaLabel="Loading" color="#00BFFF" />
                    </div>
                </Box>
                :
            <Box sx={{ pt: 2, pb: 1 }}>
                {gamePGNString &&
                    <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                            <h5 style={{ alignItems: 'center', justifyContent: 'center' }}>
                                {whiteElo > 0 ? "[" + whiteElo + "]" : ""}
                                &nbsp;&nbsp;
                                {whiteUscfId > 0 ?
                                    (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + whiteUscfId} target='_blank' rel='noreferrer'>{white}</a>)
                                    :
                                    (whiteFideId > 0 ? (<a href={'https://ratings.fide.com/profile/' + whiteFideId} target='_blank' rel='noreferrer'>{white}</a>) : white)
                                }
                                &nbsp;&nbsp;
                                {result}
                                &nbsp;&nbsp;
                                {blackUscfId > 0 ?
                                    (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + blackUscfId} target='_blank' rel='noreferrer'>{black}</a>)
                                    :
                                    (blackFideId > 0 ? (<a href={'https://ratings.fide.com/profile/' + blackFideId} target='_blank' rel='noreferrer'>{black}</a>) : black)
                                }
                                &nbsp;&nbsp;
                                {blackElo > 0 ? "[" + blackElo + "]" : ""}</h5>
                        </Grid>
                        <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                            <h6 style={{ alignItems: 'center', justifyContent: 'center' }}>
                                {uscfEventId > 0 ?
                                    (/*<a href={'http://www.uschess.org/msa/XtblMain.php?' + uscfEventId} target='_blank' rel='noreferrer'>{event}</a>*/
                                        <Link target="_blank" to={'/Games/GamesByEventID?idType=USCF&id=' + uscfEventId}>{event}</Link>)
                                    :
                                    (fideEventId > 0 ? (/*<a href={'https://ratings.fide.com/tournament_information.phtml?event=' + fideEventId} target='_blank' rel='noreferrer'>{event}</a>*/
                                        <Link target="_blank" to={'/Games/GamesByEventID?idType=FIDE&id=' + fideEventId}>{event}</Link>) : event)
                                }
                                &nbsp;&nbsp;
                                {fideEventId > 0 ?
                                    (<a href={'https://ratings.fide.com/tournament_information.phtml?event=' + fideEventId} target='_blank' rel='noreferrer'>{"[" + date + "]"}</a>)
                                    :
                                    (uscfEventId > 0 ? <a href={'http://www.uschess.org/msa/XtblMain.php?' + uscfEventId} target='_blank' rel='noreferrer'>{"[" + date + "]"}</a>
                                        : "[" + date + "]")
                                }
                            </h6>
                        </Grid>
                        {isAdmin && displayEditButton &&
                            <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                                <Button variant="contained" component={Link} to={'/Games/EditGameById/' + gameId} color="primary" >Edit Game</Button>
                                </Grid>
                            }
                        {isAdmin &&
                            <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                                <AnalyzeOnLichess studyId={"T9fzisoU"} chapterName={event}
                                    apiToken={"lip_1bQ56NtA8QuhUJU6oVFo"}
                                    pgn={gamePGNString.filter(line => !line.startsWith("[") && line.trim() !== "").join("\n")} //remove headers and keep only moves
                                />
                            </Grid>
                        }
                        <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                            {/*<PGNViewer pgn={gamePGNString} size={size} />*/}
                            <PGNViewer pgn={gamePGNString} size={(Math.min(screenSize.width, screenSize.height) * 2 / 3)} />
                            </Grid>
                    </div>
                }
                {errorMessage &&
                    <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <Grid item xs={12} alignItems="center" justifyContent="center" display="flex">
                            <h5 style={{ alignItems: 'center', justifyContent: 'center', color: 'red' }}>
                                {errorMessage}
                            </h5>
                        </Grid>
                        <Grid>
                            <SupportUs />
                        </Grid>
                    </div>
                    }

            </Box>
            }
        </div >
                
        )
}

